import React from 'react'
import { Form, Input } from 'antd'
import { MobileOutlined } from '@ant-design/icons';
import CaptchaImg from "./CaptchaImg";


export default function ImageCodeCheck(props) {
    const { handleClick, captcha, captchaImg } = props
    return (
        <div>
            <Form.Item
                name="Phone"
                // validateTrigger="onBlur"
                hasFeedback={true}
                rules={[
                    {
                        required: true,
                        message: '请输入手机号！',
                    },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: '手机号不合法！'
                    }
                ]}
            >
                <Input prefix={<MobileOutlined className="site-form-item-icon" />} placeholder="输入手机号" />
            </Form.Item>
            <CaptchaImg handleClick={handleClick} captcha={captcha} captchaImg={captchaImg}/>
        </div>
    )
}
